import useUIBp from "../../../../../../../Hooks/useUIBoilerplate";
import { treesActions } from "../../../../../../../store/slices/trees";
import ExpandedIcon from "../../../../../../../utility/misc/expandedIcon";
import IconButton from "../../../../../../UI/GeneralPurpose/IconButton";
import { tunnelTokenId } from "../../../Actions/getMachineStatus";
import loadRepositoryNode from "../../../Actions/loadRepositoryNode";

const UIText = {
  universal: {},
};

const ExpandButton = (props) => {
  const { auth, dispatch, UI } = useUIBp();
  const {
    id,
    fullPath,
    treeId,
    idx,
    loaded,
    expanded,
    isDir,
    hasChildren,
    level,
    working,
    status,
    c365ID,
  } = props;
  const tunnelToken = UI[tunnelTokenId];

  const expandIcon = ExpandedIcon(
    loaded,
    expanded,
    isDir,
    hasChildren, 
    status,
  );

  const handleExpand = () => {
    if (loaded) {
      dispatch(
        treesActions.toggleExpand({
          id: treeId,
          idx,
        })
      );
    } else {
      dispatch(
        loadRepositoryNode({
          id: level ? id : 'root'+treeId,
          root: treeId,
          idx,
          server: auth.server,
          M365server: auth.M365server,  
          tunnelToken,
          path: fullPath,
          c365ID,
        })
      );
    }
  };


  return (
    <IconButton
      {...{
        UIText,
        disabled: working || (loaded && !hasChildren) || !isDir || !!status,
        onClick: handleExpand,
        icon: expandIcon,
        sx: { padding: 0.3 },
        size: "auto",
      }}
    />
  );
};

export default ExpandButton;
